import React from "react"
import { useTheme } from "~/ui/styled"
import { Flex, StartFlex, CenterFlex, ColumnFlex, Text, IconFont } from "~components/El"
import { Avatar } from '~widgets/avatar'
import { DialogChatContentProps, NotificationCenterContentProps } from "./types"
import { formatMessageTime } from "~utils"

export const DialogChatContent: React.FC<DialogChatContentProps> = ({
  avatarProps = null,
  content = "",
  subContent = ""
}) => {
    const theme = useTheme()
    return (
    <StartFlex flexDirection="column" width="100%">
        {avatarProps && (
            <CenterFlex width="100%">
                <Avatar {...avatarProps} />
            </CenterFlex>
        )}
        {content && <Text fontSize="20px" color={theme.colors.text} fontWeight="600" mt="10px">{content}</Text>}
        {subContent && <Text fontSize="14px" color={theme.colors.infoText} mt="10px">{subContent}</Text>}
    </StartFlex>
    )
}

export const DialogShareContent: React.FC<DialogChatContentProps> = ({
  avatarProps = null,
  content = "",
  subContent = ""
}) => {
    const theme = useTheme()
    return (
    <StartFlex flexDirection="column" width="100%">
        {content && <Text fontSize="14px" color={theme.colors.text}>{content}</Text>}
        {avatarProps && (
            <CenterFlex width="100%" mt="10px">
                <Avatar {...avatarProps} />
            </CenterFlex>
        )}
        {subContent && <Text fontSize="14px" color={theme.colors.text} mt="10px">{subContent}</Text>}
    </StartFlex>
    )
}

// 通知中心弹窗
export const NotificationCenterContent: React.FC<NotificationCenterContentProps> = ({
  content = "",
  created = "",
  is_read,
  icon = "",
  label = ""
}) => {
    const theme = useTheme()

    const renderRenderable = (node: any, opts?: { fontSize?: string; fontWeight?: string; color?: string; mt?: string }) => {
        if (node === null || node === undefined || node === "") return null
        if (typeof node === "function") return renderRenderable(node(), opts)
        if (React.isValidElement(node)) return node
        if (typeof node === "string" || typeof node === "number") {
            return (
                <Text
                    fontSize={opts?.fontSize}
                    fontWeight={opts?.fontWeight as any}
                    color={opts?.color}
                    mt={opts?.mt}
                >
                    {node}
                </Text>
            )
        }
        return null
    }

    return (
    <Flex flexDirection="column" width="100%">
        <StartFlex width="100%" flexDirection="row" alignItems="center">
            <IconFont name={icon || "jytz"} size={30} color={theme.colors.primary} />
            <ColumnFlex width="auto" height="auto" flex={1} ml="10px">
                <Text fontSize="18px" fontWeight="600" color={theme.colors.text}>{label}</Text>
                <StartFlex mt="6px">
                    <StartFlex>
                        <IconFont name="sssj" size={12} color={theme.colors.secondaryText} />
                        <Text fontSize="12px" color={theme.colors.secondaryText} ml="6px">{formatMessageTime(created)}</Text>
                    </StartFlex>
                    <StartFlex width="auto" height="auto" minWidth={'max-content'} ml="12px">
                        {is_read && <IconFont name={"szyx1"} size={12} color={theme.colors.primary} />}
                        {!is_read && <CenterFlex width="8px" height="8px" bg={theme.colors.primaryText} borderRadius="4px"></CenterFlex>}
                        <Text fontSize="12px" color={is_read ? theme.colors.primary : theme.colors.primaryText} ml="6px">{is_read ? "已读" : "未读"}</Text>
                    </StartFlex>
                </StartFlex>
            
            </ColumnFlex>
        </StartFlex>

        <Text fontSize="15px" color={theme.colors.text} mt="20px">{content}</Text>
    </Flex>
    )
}
